import { render } from "./mobile-property-form.vue?vue&type=template&id=4736f23a&scoped=true&ts=true"
import script from "./mobile-property-form.vue?vue&type=script&lang=ts"
export * from "./mobile-property-form.vue?vue&type=script&lang=ts"

import "./mobile-property-form.vue?vue&type=style&index=0&id=4736f23a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4736f23a"]])

export default __exports__